import { FETCH_PROJECT_COMMENTS_RESPONSES_SUCCESS, FETCH_PROJECT_COMMENTS_RESPONSES_REQUEST, FETCH_PROJECT_COMMENTS_RESPONSES_FAILURE} from "./ProjectCommentsResponsesTypes";

const initialState = {
  loading: true,
  data: [],
  errorMsg: '',
};


const ProjectCommentsResponseReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROJECT_COMMENTS_RESPONSES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_PROJECT_COMMENTS_RESPONSES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        errorMsg: '',
      };
    case FETCH_PROJECT_COMMENTS_RESPONSES_FAILURE:
      return {
        ...state,
        loading: false,
        data: [],
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default ProjectCommentsResponseReducer 